import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'cre-ng';

import { DriverSalary } from '@app/core/model/payment.model';
import { IPaymentService } from '@app/core/services/interface/IPaymentService';
import { DriverPayType } from '@app/core/model/driver-paytype.model';

@Injectable()
export class PaymentService extends BaseService implements IPaymentService {
  constructor(protected httpClient: HttpClient) {
    super({ serviceApiDomain: window.__env.ngSettings.serviceApiDomain }, httpClient);
  }

  getDriverPayType(driverCode: string): Promise<DriverPayType> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    return this.httpClient
      .get<DriverPayType>(this.serviceUrl + `/sotbonus/bonuspaytype/${driverCode}`, requestOptions)
      .toPromise();
  }

  protected getEndPoint(): string {
    return '/safeandontime/api/v1';
  }
}
